// extracted by mini-css-extract-plugin
module.exports = {"header":"infoBus_header__1YBvB","chofer":"infoBus_chofer__101O_","configuration":"infoBus_configuration__15gpz"};